"use client";
import { jsxs as a, jsx as i } from "react/jsx-runtime";
const s = ({
  title: e,
  titleId: r,
  desc: n,
  descId: o,
  ...t
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": o,
    ...t,
    children: [
      n ? /* @__PURE__ */ i("desc", { id: o, children: n }) : null,
      e ? /* @__PURE__ */ i("title", { id: r, children: e }) : null,
      /* @__PURE__ */ i(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m4 13.9999 1.5747 6.2986c.0442.1771.0664.2657.0926.343a2 2 0 0 0 1.7312 1.3518c.0814.0066.1727.0066.3553.0066.2286 0 .343 0 .4393-.0093a2 2 0 0 0 1.7976-1.7976C10 20.0967 10 19.9823 10 19.7537V5.4999m8.5 8c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5m-8.25-1H6.5C4.0147 5.5 2 7.5146 2 10s2.0147 4.5 4.5 4.5h3.75c1.7664 0 3.9272.9469 5.5943 1.8557.9725.5301 1.4588.7952 1.7773.7562.2953-.0362.5186-.1688.6917-.4108.1867-.2609.1867-.7831.1867-1.8274V5.1262c0-1.0443 0-1.5664-.1867-1.8274-.1731-.242-.3964-.3746-.6917-.4108-.3185-.039-.8048.2261-1.7773.7563-1.6671.9087-3.8279 1.8556-5.5943 1.8556"
        }
      )
    ]
  }
);
export {
  s as default
};
